import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireBusiness?: boolean;
  requireAuth?: boolean; // New prop to require authentication
  redirectTo?: string; // Custom redirect destination
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  requireBusiness = false,
  requireAuth = true,
  redirectTo
}) => {
  const { isAuthenticated, businessId, loading } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute: loading=', loading, 'isAuthenticated=', isAuthenticated, 'businessId=', businessId, 'requireBusiness=', requireBusiness, 'requireAuth=', requireAuth);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }

  // If authentication is required but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    console.log('ProtectedRoute: Not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  // If user is authenticated but trying to access auth pages, redirect to dashboard
  if (!requireAuth && isAuthenticated) {
    console.log('ProtectedRoute: Authenticated user trying to access auth page, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  // If business is required and user doesn't have one, redirect to create business
  if (requireBusiness && isAuthenticated && !businessId) {
    console.log('ProtectedRoute: Business required but no businessId, redirecting to create-business');
    return <Navigate to="/create-business" replace />;
  }

  // If user has business but trying to access business creation page, redirect to dashboard
  if (!requireBusiness && isAuthenticated && businessId && location.pathname === '/create-business') {
    console.log('ProtectedRoute: User with business trying to access business creation, redirecting to dashboard');
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;